import { createUseStyles } from "react-jss";
import * as Mixins from "../../theme/Mixins";

function getHeight(freeform, { TextFontSize, BaseFontSize, InputHeight, BorderWidth }) {
    if (freeform || TextFontSize > BaseFontSize) return undefined;
    return InputHeight + BorderWidth * 2;
}

export default createUseStyles({
    inputBox: ({ theme, focused, style, freeform, accessoryLeft, accessoryRight }) => ({
        boxSizing: "border-box",
        color: Mixins.foregroundColor(theme, Mixins.controlBackgroundColor(theme)),
        composes: "input-box",
        height: getHeight(freeform, theme),
        lineHeight: freeform ? `${theme.LineHeight}px` : `${theme.InputHeight}px`,
        overflow: "hidden",
        position: "relative",
        transition: "color 200ms, box-shadow 200ms, border-color 200ms",
        verticalAlign: "top",
        width: "100%",
        ...style,
        "& [type=tel], & [type=number]": {
            textAlign: "right",
        },
        "& select, & input, & textarea, & button": {
            backgroundColor: Mixins.inputBackgroundColor(theme, focused),
            border: [
                [
                    theme.BorderWidth,
                    "solid",
                    focused ? theme.PrimaryColor : theme.ControlBorderColor,
                ],
            ],
            borderRadius:
                theme.ControlAlpha === 0 && theme.BorderWidth === 0
                    ? 0
                    : Math.min(theme.BorderRadius, theme.InputHeight / 2),
            borderBottom:
                theme.ControlAlpha === 0 && theme.BorderWidth === 0
                    ? [[3, "solid", theme.ControlBorderColor]]
                    : "",
            boxSizing: "border-box",
            color: "inherit",
            display: "block",
            fontFamily: "inherit",
            fontSize: "inherit",
            height: "100%",
            lineHeight: "inherit",
            outline: "none",
            overflow: "auto",
            padding: [[4, 16]],
            paddingLeft: accessoryLeft ? 38 : undefined,
            paddingRight: accessoryRight ? 38 : undefined,
            resize: "none",
            textAlign: "left",
            transition: "background-color 200ms, border-color 200ms",
            WebkitAppearance: "none",
            width: "100%",
        },
        "& button": {
            padding: [[0, 16]],
        },
        "& textarea": {
            maxWidth: "100%",
            minWidth: "100%",
            resize: "vertical",
            minHeight: getHeight(false, theme),
        },
        "& option": {
            color: "black",
        },
    }),
    inputBoxFocused: {
        composes: "input-box--focused",
    },
    inputBoxAccessory: {
        bottom: 0,
        composes: "input-box__accessory",
        fontSize: ({ theme }) => theme.TextFontSize,
        margin: "auto",
        pointerEvents: "none",
        position: "absolute",
        top: 0,
    },
    inputBoxAccessoryLeft: {
        composes: "input-box__accessory-left",
        left: 0,
        marginLeft: 16,
    },
    inputBoxAccessoryRight: {
        composes: "input-box__accessory-right",
        right: 0,
        marginRight: 16,
    },
});
